import "./App.css";
import "./styles/brand-theme.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { CartProvider } from "./context/CartContext";
import { BrandProvider } from "./components/BrandProvider";
import Home from "./pages/Home";
import ProductDetail from "./pages/ProductDetail";
import CartPage from "./pages/CartPage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import CheckoutPage from "./pages/CheckoutPage";
import SearchResultsPage from "./pages/SearchResultsPage";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminProductsNew from "./pages/admin/AdminProductsNew";
import AdminOrders from "./pages/admin/AdminOrders";
import AdminQuoteRequests from "./pages/admin/AdminQuoteRequests";
import AdminPromoCodes from "./pages/admin/AdminPromoCodes";
import AdminClients from "./pages/admin/AdminClients";
import AdminPricing from "./pages/admin/AdminPricing";
import AdminDelivery from "./pages/admin/AdminDelivery";
import AdminImport from "./pages/admin/AdminImport";
import AdminCollectionsOrder from "./pages/admin/AdminCollectionsOrder";
import AdminDatabaseCheck from "./pages/admin/AdminDatabaseCheck";
import QuoteRequestPage from "./pages/QuoteRequestPage";
import StoreDroitPage from "./pages/StoreDroitPage";
import StoreDoublePentePage from "./pages/StoreDoublePentePage";
import LambrequinPage from "./pages/LambrequinPage";
import PergolaPage from "./pages/PergolaPage";
import BriseVuePage from "./pages/BriseVuePage";
import ToileAuMetrePage from "./pages/ToileAuMetrePage";
import DevisMarquageFlocagePage from "./pages/DevisMarquageFlocagePage";
import DevisMarquageLumineuxPage from "./pages/DevisMarquageLumineuxPage";
import ProLoginPage from "./pages/ProLoginPage";
import ProDashboard from "./pages/ProDashboard";
import ProDocumentsPage from "./pages/ProDocumentsPage";
import ProQuoteRequestPage from "./pages/ProQuoteRequestPage";
import ProForgotPasswordPage from "./pages/ProForgotPasswordPage";
import ProResetPasswordPage from "./pages/ProResetPasswordPage";
import AdminProUsers from "./pages/admin/AdminProUsers";
import AdminTooltips from "./pages/admin/AdminTooltips";
import CGVPage from "./pages/CGVPage";
import MentionsLegalesPage from "./pages/MentionsLegalesPage";
import ContactPage from "./pages/ContactPage";
import GarantiePage from "./pages/GarantiePage";
import FAQPage from "./pages/FAQPage";
import BlogPage from "./pages/BlogPage";
import BlogPostPage from "./pages/BlogPostPage";
import ServicePosePage from "./pages/ServicePosePage";
import AdminInstallationPricing from "./pages/admin/AdminInstallationPricing";
import AdminCloudinaryPage from "./pages/admin/AdminCloudinaryPage";
import AssuranceMesurePage from "./pages/AssuranceMesurePage";
import ServiceChronosPage from "./pages/ServiceChronosPage";
import FloatingPhoneButton from "./components/FloatingPhoneButton";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrandProvider>
          <CartProvider>
            <BrowserRouter>
            <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/store-droit" element={<StoreDroitPage />} />
            <Route path="/store-double-pente" element={<StoreDoublePentePage />} />
            <Route path="/lambrequin" element={<LambrequinPage />} />
            <Route path="/pergola" element={<PergolaPage />} />
            <Route path="/brise-vue" element={<BriseVuePage />} />
            <Route path="/toile-au-metre" element={<ToileAuMetrePage />} />
            <Route path="/recherche" element={<SearchResultsPage />} />
            <Route path="/produit/:slug" element={<ProductDetail />} />
            <Route path="/product/:slug" element={<ProductDetail />} />
            <Route path="/panier" element={<CartPage key="cart" />} />
            <Route path="/commande" element={<CheckoutPage key="checkout" />} />
            <Route path="/payment-success" element={<PaymentSuccessPage />} />
            <Route path="/demande-devis" element={<QuoteRequestPage />} />
            <Route path="/devis-marquage-flocage" element={<DevisMarquageFlocagePage />} />
            <Route path="/devis-marquage-lumineux-flocage" element={<DevisMarquageLumineuxPage />} />
            <Route path="/cgv" element={<CGVPage />} />
            <Route path="/assurance-mesure" element={<AssuranceMesurePage />} />
            <Route path="/service-chronos" element={<ServiceChronosPage />} />
            <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/garantie" element={<GarantiePage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/service-pose" element={<ServicePosePage />} />
            <Route path="/pro/login" element={<ProLoginPage />} />
            <Route path="/pro/dashboard" element={<ProDashboard />} />
            <Route path="/pro/documents" element={<ProDocumentsPage />} />
            <Route path="/pro/devis" element={<ProQuoteRequestPage />} />
            <Route path="/pro/forgot-password" element={<ProForgotPasswordPage />} />
            <Route path="/pro/reset-password" element={<ProResetPasswordPage />} />
            <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/products" element={<AdminProductsNew />} />
            <Route path="/admin/orders" element={<AdminOrders />} />
            <Route path="/admin/quote-requests" element={<AdminQuoteRequests />} />
            <Route path="/admin/promo-codes" element={<AdminPromoCodes />} />
            <Route path="/admin/clients" element={<AdminClients />} />
            <Route path="/admin/pricing" element={<AdminPricing />} />
            <Route path="/admin/delivery" element={<AdminDelivery />} />
            <Route path="/admin/import" element={<AdminImport />} />
            <Route path="/admin/collections-order" element={<AdminCollectionsOrder />} />
            <Route path="/admin/database-check" element={<AdminDatabaseCheck />} />
            <Route path="/admin/pro-users" element={<AdminProUsers />} />
            <Route path="/admin/tooltips" element={<AdminTooltips />} />
            <Route path="/admin/installation-pricing" element={<AdminInstallationPricing />} />
            <Route path="/admin/cloudinary" element={<AdminCloudinaryPage />} />
          </Routes>
          <FloatingPhoneButton />
            </BrowserRouter>
          </CartProvider>
        </BrandProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
